import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApiResponse, OrganizationContactResponse } from "../../types/certWatch";
import { getCCOsNeedAttentionByOrgId } from "../thunks/ccoAdvanceTab2Thunk";

interface CertConnectState {
  ccoLists: OrganizationContactResponse[];
  Loading: boolean;
  error: string | null;
  activeFlag: number;
  totalNeedAttentionCount: number;
  
  // Add pagination state for Tab2
  Page: number;
  PageSize: number;
  totalPages:number;
   totalCertifiedCount: number;  
    sortBy: string;
  sortOrder: "asc" | "desc"; 
  statusFilter?: number | null;
      FirstNameSearch : string | null;  
      LastNameSearch : string | null;  
      CcoIdSearchTermTab2 : string | null; 
    appliedFiltersTab2: {  
    FirstNameSearchTab2: boolean;
    LastNameSearchTab2: boolean;
    CcoIdSearchTermTab2: boolean;
    ActionRequired:boolean;
    resetFilters?:boolean
  }; 
}

const initialState: CertConnectState = {
  ccoLists: [],
  Loading: false,
  error: null,
  activeFlag: 0,
  totalNeedAttentionCount: 0,
  Page: 1,
  PageSize: 25,
  totalPages: 0,
  totalCertifiedCount: 0,
  sortBy: "LastName",
  sortOrder: "asc",
  statusFilter: null,
  FirstNameSearch: "",
  LastNameSearch: "",
  CcoIdSearchTermTab2: "",
  appliedFiltersTab2: {
    FirstNameSearchTab2: false,
    LastNameSearchTab2: false,
    CcoIdSearchTermTab2: false,
    ActionRequired:false,
    resetFilters:false
  }
};

const CCoAdvanceTab2Slice = createSlice({
  name: "ccoAdvanceTab2",
  initialState,
  reducers: {
    reset(state) {
      state.ccoLists = [];
      state.Loading = false;
      state.error = null;
    },
    setActiveFlag(state, action: PayloadAction<number>) {
      state.activeFlag = action.payload;
    },
    // --- Add these pagination reducers ---
    setPageTab2(state, action: PayloadAction<number>) {
      state.Page = action.payload;
    },
    setPageSizeTab2(state, action: PayloadAction<number>) {
      state.PageSize = action.payload;
    },
      setSortTab2: (state, action: PayloadAction<{ sortBy: string; sortOrder: 'asc' | 'desc' }>) => {
  state.sortBy = action.payload.sortBy;
  state.sortOrder = action.payload.sortOrder;
 // state.Page = 1; 
},


    // ----------Status Filter ----------
    setStatusFilterTab2(state, action: PayloadAction<number | null>) {
      state.statusFilter = action.payload;
      state.Page = 1;
    },
  setFirstNameSearchTermTab2(state, action: PayloadAction<string>) {
    state.FirstNameSearch = action.payload;
          state.Page = 1;

  },
   setLastNameSearchTermTab2(state, action: PayloadAction<string>) {
    state.LastNameSearch = action.payload;
          state.Page = 1;

  },
   setCcoIdSearchTermTab2(state, action: PayloadAction<string>) {
    state.CcoIdSearchTermTab2 = action.payload;
          state.Page = 1;
  },
  resetCcoIdSearchTermTab2: (state) => {
  state.CcoIdSearchTermTab2 = "";
  state.appliedFiltersTab2.CcoIdSearchTermTab2 = false;
},
    setAppliedFilterTab2(state, action: PayloadAction<{ filter: keyof CertConnectState['appliedFiltersTab2'], value: boolean }>) {
    state.appliedFiltersTab2[action.payload.filter] = action.payload.value;
  }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCCOsNeedAttentionByOrgId.pending, (state) => {
        state.Loading = true;
        state.error = null;
      })
      .addCase(
        getCCOsNeedAttentionByOrgId.fulfilled,
        (state, action: PayloadAction<ApiResponse<OrganizationContactResponse>>) => {
          state.Loading = false;
          state.ccoLists = action.payload.Data.Items; 
          state.totalNeedAttentionCount = action.payload.Data.TotalCount;
          state.totalPages = Math.ceil(action.payload.Data.TotalCount / state.PageSize);

        }
      )
      .addCase(getCCOsNeedAttentionByOrgId.rejected, (state, action) => {
        state.Loading = false;
        state.error = action.payload
          ? (action.payload as string)
          : action.error.message || "Failed to fetch CCOs";
      });
  },
});

export const { reset, setActiveFlag, setPageTab2, setPageSizeTab2, setSortTab2,setStatusFilterTab2,setFirstNameSearchTermTab2,
    setLastNameSearchTermTab2, setCcoIdSearchTermTab2, setAppliedFilterTab2,resetCcoIdSearchTermTab2} = CCoAdvanceTab2Slice.actions;
export default CCoAdvanceTab2Slice.reducer;
